import React from 'react';
import styles from './Card.module.css';

const Card = ({ title, children, className = '', onClick = null, ...props }) => {
  const cardClass = [styles.card, className].filter(Boolean).join(' ');

  return (
    <div className={cardClass} onClick={onClick} {...props}>
      {title && <h3 className={styles.title}>{title}</h3>}
      <div className={styles.body}>{children}</div>
    </div>
  );
};

export default Card;
